import { createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`
body, body * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
}

body{
    overflow-x: hidden;
}
  
`

export default GlobalStyle;